// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/saf.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-screen {
  display: flex !important;
  flex-direction: column;
  justify-content: space-between;
  background-color: #000;
}

.safariBackground {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.photos {
  background-color: white;
}
.home-screen {
  padding: 20px; 
}

.apps-grid {
  display: grid;
  grid-template-columns: repeat(4, 5.5em);
  gap: .8em;
  padding: 2px;
  overflow: hidden;
}

.dock {
  display: flex !important;
  justify-content: space-around;
  padding: 10px;
  background: #ffffff54;
  border-radius: 40px;
  margin: 0 10px;
  margin-bottom: 15px;
}

.app-icon {
  display: flex;
  width: 2.15em;
  height: 2.15em;
  border-radius: 1.1em;
  margin-bottom: 4px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.1em;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
}

.app-icon img {
  width: 3.5em;
  max-width: 5em;
  height: 3.5em;
}

.app-icondock {
  display: flex;
  width: 2.25em;
  height: 2.25em;
  border-radius: 1.1em;
  margin-bottom: 4px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.1em;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
}

.app-icondock img {
  width: 3em;
  max-width: 5.5em;
  height: 3em;
}

.app-label {
  font-size: 12px;
  color: white;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 60px;
}

.app-icon label {
  font-size: 12px;
  color: rgb(255, 255, 255);
  text-align: center;
  margin-top: 4px;
}

.app-icon-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 8px;
  text-decoration: none;
}

/* Responsive grid setup */
@media (max-width: 390px) {
  .home-screen, .second-screen {
    height: 83vh;
  }

  .apps-grid {
    gap: .5em;
    grid-template-columns: repeat(4, 5em);
  }

  .app-icon {
    width: 1.8em;
    height: 1.8em;
  }

  .app-icon img {
    width: 3em;
    height: 3em;
  }

  .app-icondock {
    width: 2em;
    height: 2em;
  }

  .app-icondock img {
    width: 2.5em;
    height: 2.5em;
  }
}

@media (min-width: 768px) {
  .dock {
    margin: 0 auto;
    justify-content: center;
  }
}




@media (max-width: 389px) {
  .home-screen {
    grid-template-columns: repeat(4, 60px);
    padding: 10px;
  }
}

@media (min-height: 915px) and (max-width: 390px) {
  .home-screen {
    grid-template-columns: repeat(4, 60px);
    padding: 10px;
  }
}


@media (min-width: 410px) and (max-width: 414px) {

  .home-screen {
    grid-template-columns: repeat(4, 60px);
    padding: 10px;
  }
}

@media (min-width: 412px) {
  .home-screen {
    grid-template-columns: repeat(4, 60px);
  
  }
}



@media (max-width: 320px) {
  .home-screen {
    grid-template-columns: repeat(4, 60px);
    padding: 10px !important;
  }

  .app-icon {
    width: 60px;
    height: 60px;
  }

  .app-icon img {
    width: 40px;
    height: 40px;
  }
}

.dock {
  display: flex;
  justify-content: space-around;
  padding: 10px;
  background: #ffffff54;
  border-radius: 40px;
  margin: 0 10px;
  margin-bottom: 15px;
}

.home-screen {
  display: flex !important;
  flex-direction: column;
  justify-content: space-between;
  background-color: #000;
}

.dock {
  display: flex !important;
  justify-content: space-around;
  padding: 10px;
  background: #ffffff54;
  border-radius: 40px;
  margin: 0 10px;
  margin-bottom: 15px;
}

`, "",{"version":3,"sources":["webpack://./src/components/css/HomeScreen.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,yDAAuC;AACzC;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE;IACE,YAAY;EACd;;EAEA;IACE,SAAS;IACT,qCAAqC;EACvC;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;IACd,uBAAuB;EACzB;AACF;;;;;AAKA;EACE;IACE,sCAAsC;IACtC,aAAa;EACf;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,aAAa;EACf;AACF;;;AAGA;;EAEE;IACE,sCAAsC;IACtC,aAAa;EACf;AACF;;AAEA;EACE;IACE,sCAAsC;;EAExC;AACF;;;;AAIA;EACE;IACE,sCAAsC;IACtC,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".home-screen {\n  display: flex !important;\n  flex-direction: column;\n  justify-content: space-between;\n  background-color: #000;\n}\n\n.safariBackground {\n  background-image: url('../img/saf.png');\n}\n\n.photos {\n  background-color: white;\n}\n.home-screen {\n  padding: 20px; \n}\n\n.apps-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 5.5em);\n  gap: .8em;\n  padding: 2px;\n  overflow: hidden;\n}\n\n.dock {\n  display: flex !important;\n  justify-content: space-around;\n  padding: 10px;\n  background: #ffffff54;\n  border-radius: 40px;\n  margin: 0 10px;\n  margin-bottom: 15px;\n}\n\n.app-icon {\n  display: flex;\n  width: 2.15em;\n  height: 2.15em;\n  border-radius: 1.1em;\n  margin-bottom: 4px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1.1em;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);\n}\n\n.app-icon img {\n  width: 3.5em;\n  max-width: 5em;\n  height: 3.5em;\n}\n\n.app-icondock {\n  display: flex;\n  width: 2.25em;\n  height: 2.25em;\n  border-radius: 1.1em;\n  margin-bottom: 4px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1.1em;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);\n}\n\n.app-icondock img {\n  width: 3em;\n  max-width: 5.5em;\n  height: 3em;\n}\n\n.app-label {\n  font-size: 12px;\n  color: white;\n  text-align: center;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  width: 60px;\n}\n\n.app-icon label {\n  font-size: 12px;\n  color: rgb(255, 255, 255);\n  text-align: center;\n  margin-top: 4px;\n}\n\n.app-icon-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 8px;\n  text-decoration: none;\n}\n\n/* Responsive grid setup */\n@media (max-width: 390px) {\n  .home-screen, .second-screen {\n    height: 83vh;\n  }\n\n  .apps-grid {\n    gap: .5em;\n    grid-template-columns: repeat(4, 5em);\n  }\n\n  .app-icon {\n    width: 1.8em;\n    height: 1.8em;\n  }\n\n  .app-icon img {\n    width: 3em;\n    height: 3em;\n  }\n\n  .app-icondock {\n    width: 2em;\n    height: 2em;\n  }\n\n  .app-icondock img {\n    width: 2.5em;\n    height: 2.5em;\n  }\n}\n\n@media (min-width: 768px) {\n  .dock {\n    margin: 0 auto;\n    justify-content: center;\n  }\n}\n\n\n\n\n@media (max-width: 389px) {\n  .home-screen {\n    grid-template-columns: repeat(4, 60px);\n    padding: 10px;\n  }\n}\n\n@media (min-height: 915px) and (max-width: 390px) {\n  .home-screen {\n    grid-template-columns: repeat(4, 60px);\n    padding: 10px;\n  }\n}\n\n\n@media (min-width: 410px) and (max-width: 414px) {\n\n  .home-screen {\n    grid-template-columns: repeat(4, 60px);\n    padding: 10px;\n  }\n}\n\n@media (min-width: 412px) {\n  .home-screen {\n    grid-template-columns: repeat(4, 60px);\n  \n  }\n}\n\n\n\n@media (max-width: 320px) {\n  .home-screen {\n    grid-template-columns: repeat(4, 60px);\n    padding: 10px !important;\n  }\n\n  .app-icon {\n    width: 60px;\n    height: 60px;\n  }\n\n  .app-icon img {\n    width: 40px;\n    height: 40px;\n  }\n}\n\n.dock {\n  display: flex;\n  justify-content: space-around;\n  padding: 10px;\n  background: #ffffff54;\n  border-radius: 40px;\n  margin: 0 10px;\n  margin-bottom: 15px;\n}\n\n.home-screen {\n  display: flex !important;\n  flex-direction: column;\n  justify-content: space-between;\n  background-color: #000;\n}\n\n.dock {\n  display: flex !important;\n  justify-content: space-around;\n  padding: 10px;\n  background: #ffffff54;\n  border-radius: 40px;\n  margin: 0 10px;\n  margin-bottom: 15px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
